<template>
  <div class="staff-salary">
    <c-table
      ref="table"
      :columns="columns"
      url="/salary/get"
      :fetchPage="false"
    >
      <el-table-column type="expand" slot="expand">
        <template v-slot="{ row }">
          <table>
            <tr>
              <th><span>姓名：</span><span>{{row.name}}</span></th>
              <th><span>工号：</span><span>{{row.gongid}}</span></th>
            </tr>
            <tr>
              <td><span>绩效年月：</span><span>{{row.performmonth}}</span></td>
              <td></td>
            </tr>
            <tr>
              <td><span>绩效等级：</span><span>{{row.performlevel}}</span></td>
              <td><span>绩效成绩：</span><span>{{row.performvalue}}</span></td>
            </tr>
            <tr v-if="row.remark">
              <td><span>绩效评语(当期)：</span></td>
            </tr>
            <tr v-if="row.remark">
              <td colspan="2"><span></span><span class="remarkContent" v-html="row.remark"></span></td>
            </tr>
            <tr>
              <td><span>基本工资：</span><span>{{row.basesalary}}</span></td>
              <td><span>岗位工资：</span><span>{{row.postsalary}}</span></td>
            </tr>
            <tr>
              <td><span>加班工资：</span><span>{{row.otsalary}}</span></td>
              <td><span>补贴：</span><span>{{row.subsidy}}</span></td>
            </tr>
            <tr>
              <td><span>其他福利：</span><span>{{row.welfare}}</span></td>
              <td><span>福利包：</span><span>{{row.welfare2}}</span></td>
            </tr>
            <tr>
              <td><span>本月项目绩效奖金：</span><span>{{row.performbonus1}}</span></td>
              <td><span>本月部门绩效奖金：</span><span>{{row.performbonus2}}</span></td>
            </tr>
            <tr>
              <td><span>补发绩效奖金：</span><span>{{row.performbonus3}}</span></td>
              <td><span>绩效奖金总计：</span><span>{{row.performbonus}}</span></td>
            </tr>
            <tr>
              <td><span>其他奖金：</span><span>{{row.otherbonus}}</span></td>
              <td><span>请假扣款：</span><span>{{row.vacate}}</span></td>
            </tr>
            <tr>
              <td><span>子女教育专项：</span><span>{{row.children}}</span></td>
              <td><span>住房租金专项：</span><span>{{row.hosue1}}</span></td>
            </tr>
            <tr>
              <td><span>住房贷款利息专项：</span><span>{{row.hosue2}}</span></td>
              <td><span>赡养老人专项：</span><span>{{row.parent}}</span></td>
            </tr>

            <tr>
              <td><span>继续教育专项：</span><span>{{row.education}}</span></td>
              <td></td>
            </tr>
            <tr>
              <td><span>社保-公司：</span><span>{{row.social1}}</span></td>
              <td><span>社保-个人：</span><span>{{row.social2}}</span></td>
            </tr>
            <tr>
              <td><span>公积金-公司：</span><span>{{row.house1}}</span></td>
              <td><span>公积金-个人：</span><span>{{row.house2}}</span></td>
            </tr>
            <tr>
              <td><span>公司支付：</span><span>{{row.total}}</span></td>
              <td><span>代扣个税：</span><span>{{row.tax}}</span></td>
            </tr>
            <tr>
              <th><span>实发工资：</span><span>{{row.real}}</span></th>
              <th></th>
            </tr>
          </table>
        </template>
      </el-table-column>
      <el-table-column slot="name" label="姓名" min-width="100">
        <template v-slot="{ row }">
          <el-tooltip class="item" effect="dark" content="左侧箭头可展开详细信息" placement="top" :open-delay="300">
            <span>{{row.name}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column slot="gongid" label="工号" min-width="100">
        <template v-slot="{ row }">
          <el-tooltip class="item" effect="dark" content="左侧箭头可展开详细信息" placement="top" :open-delay="300">
            <span>{{row.gongid}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column slot="month" label="工资年月" min-width="100">
        <template v-slot="{ row }">
          <el-tooltip class="item" effect="dark" content="左侧箭头可展开详细信息" placement="top" :open-delay="300">
            <span>{{row.month}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column slot="operation" label="绩效明细" fixed="right" width="100">
        <template v-slot="{ row }">
          <el-button type="primary" @click="showDetail(row)">查看</el-button>
        </template>
      </el-table-column>
    </c-table>
    <el-dialog
      custom-class="detail-dialog"
      title='绩效明细'
      top="10vh"
      :visible.sync="visible"
      width="60%"
      @closed="dialogClose"
    >
      <p class="explain"><span>绩效说明：</span> {{nowDetail.explain}}</p>
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <span>当期绩效</span>
            <span>（成绩：{{nowDetail.performvalue}}，</span>
            <span>等级：{{nowDetail.performlevel}}）</span>
          </template>
          <p><span>时间</span><span>部门或项目</span><span>奖金</span></p>
          <p v-for="(item, index) in current" :key="index">
            <span>{{item.time}}</span>
            <span>{{item.what}}</span>
            <span>{{item.value}}</span>
          </p>
        </el-collapse-item>
        <el-collapse-item name="2" title="补发绩效">
          <p><span>时间</span><span>部门或项目</span><span>奖金</span></p>
          <p v-for="(item, index) in reissue" :key="index">
            <span>{{item.time}}</span>
            <span>{{item.what}}</span>
            <span>{{item.value}}</span>
          </p>
        </el-collapse-item>
        <el-collapse-item v-if="nowDetail.remark" name="3" title="绩效评语（当期）">
          <p v-html="nowDetail.remark"></p>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </div>
</template>

<script>
import CTable from '@/components/common/table'

export default {
  components: { CTable },
  data() {
    return {
      columns: [
        { slot: 'expand' },
        { slot: 'name' },
        { slot: 'gongid' },
        { slot: 'month' },
        // { prop: 'basesalary', label: '基本工资', width: 100 },
        // { prop: 'postsalary', label: '岗位工资', width: 100 },
        // { prop: 'otsalary', label: '加班工资', width: 100 },
        // { prop: 'welfare', label: '其他福利', width: 100 },
        // { prop: 'otherbonus', label: '其他奖金', width: 100 },
        // { prop: 'subsidy', label: '补贴' },
        // { prop: 'welfare2', label: '福利包' },
        // { prop: 'performmonth', label: '绩效月份', width: 100 },
        // { prop: 'performvalue', label: '绩效成绩', width: 100 },
        // { prop: 'performlevel', label: '绩效等级', width: 100 },
        // { prop: 'performbonus', label: '绩效奖金', width: 100 },
        // { prop: 'social1', label: '社保-公司', width: 120 },
        // { prop: 'social2', label: '社保-个人', width: 120 },
        // { prop: 'house1', label: '公积金-公司', width: 120 },
        // { prop: 'house2', label: '公积金-个人', width: 120 },
        // { prop: 'tax', label: '代扣个税', width: 100 },
        // { prop: 'vacate', label: '请假扣款', width: 100 },
        // { prop: 'total', label: '公司支付', width: 100 },
        // { prop: 'real', label: '实发工资', width: 100 },
        // { prop: 'time2', label: '工资发放时间', width: 120 },
        // { prop: 'children', label: '子女教育专项', width: 120 },
        // { prop: 'hosue1', label: '住房租金专项', width: 120 },
        // { prop: 'hosue2', label: '住房贷款利息专项', width: 150 },
        // { prop: 'parent', label: '赡养老人专项', width: 120 },
        // { prop: 'education', label: '继续教育专项', width: 120 },
        // { slot: 'remark' },
        // { prop: 'performbonus1', label: '本月项目绩效奖金', width: 150 },
        // { prop: 'performbonus2', label: '本月部门绩效奖金', width: 150 },
        // { prop: 'performbonus3', label: '补发绩效奖金', width: 120 },
        { slot: 'operation' }
      ],
      visible: false,
      activeNames: ['1', '2', '3'],
      nowDetail: {},
      current: [],
      reissue: []
    }
  },
  methods: {
    showRemark(row) {
      this.remark = row.remark
    },
    dialogClose() {
      this.activeNames = ['1', '2', '3']
    },
    showDetail(row) {
      this.visible = true
      this.$http.post('/salary/get2', { fileid: row.fileid }).then(res => {
        this.nowDetail = { ...row, explain: res.data.remark }
        this.current = []
        this.reissue = []
        res.data.data.map(x => {
          if (x.dangqi === 1) {
            this.current.push(x)
          } else {
            this.reissue.push(x)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.staff-salary {
  .el-table {
    .el-table__expanded-cell {
      padding: 12px 48px;
      table {
        tr {
          th, td {
            span {
              &:first-child { color: #999; }
              &:nth-child(2) { color: #777; }
            }
            height: 36px;
            width: 300px;
            padding-left: 12px;
            border: 0;
            .remarkContent{
              line-height: 2;
            }
          }
        }
      }
    }
  }
  .detail-dialog {
    .el-dialog__body {
      padding: 8px 20px 20px;
      .explain {
        margin-bottom: 15px;
        line-height: 1.5;
        span {
          color: #666;
        }
      }
      .el-collapse-item__header {
        font-size: 14px;
        color: #666;
      }
      .el-collapse-item__content {
        p {
          line-height: 2;
          span {
            display: inline-block;
            &:first-child {
              width: 180px;
            }
            &:nth-child(2) {
              width: 300px;
            }
          }
        }
      }
    }
  }
}
</style>
